module.exports = __webpack_public_path__ + "static/img/15.e97a6e2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/20/zh/15.png
// module id = CoMX
// module chunks = 0